import { FormBeforeSendError } from 'Helpers/form/errors/FormBeforeSendError';

export class FormBeforeSendValidationError extends FormBeforeSendError {
  constructor(message = 'One or more fields are invalid') {
    super(message);
    this.name = 'FormBeforeSendValidationError';
  }
}
